// API Configuration
const getApiBaseUrl = () => {
  // Use environment variable if provided
  if (process.env.REACT_APP_API_URL) {
    return `${process.env.REACT_APP_API_URL}/api`;
  }
  
  // In development, use localhost backend
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8000/api';
  }
  
  // In production, use relative URLs (same domain)
  return '/api';
};

const API_CONFIG = {
  BASE_URL: getApiBaseUrl()
};

// Helper function to build complete API URLs
export const buildApiUrl = (path) => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_CONFIG.BASE_URL}/${cleanPath}`;
};

export default API_CONFIG;